/**
 * Disable Module Confirmation Dialog
 * Warns users before disabling critical modules (PMS, AI, etc.)
 */

import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertTriangle, X } from 'lucide-react';

export function DisableModuleDialog({ 
  open, 
  onOpenChange, 
  moduleName,
  affectedFeatures = [],
  onConfirm 
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="disable-module-dialog">
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-full bg-destructive/10 flex items-center justify-center">
              <AlertTriangle className="w-5 h-5 text-destructive" />
            </div>
            <AlertDialogTitle className="heading-font text-xl">
              Disable {moduleName}?
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-sm">
            This action will disable critical functionality. Please review the impact before proceeding.
          </AlertDialogDescription>
        </AlertDialogHeader>
        
        {affectedFeatures.length > 0 && (
          <Alert variant="destructive" className="my-4">
            <X className="h-4 w-4" />
            <AlertDescription>
              <p className="font-medium mb-2">The following features will be hidden or disabled:</p>
              <ul className="list-disc list-inside space-y-1 text-xs">
                {affectedFeatures.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
            </AlertDescription>
          </Alert>
        )}
        
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="disable-module-cancel">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            data-testid="disable-module-confirm"
          >
            Disable {moduleName}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
